import { render, staticRenderFns } from "./DocumentTemplateCreateForm.vue?vue&type=template&id=62404ec4&"
import script from "./DocumentTemplateCreateForm.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports